import { useConfigureEnterpriseRoutes } from "../features/enterprise/useConfigureEnterpriseRoutes";
import { useConfigureOnPremRoutes } from "../features/onprem-setup/useConfigureOnPremRoutes";

export function useConfigureRoutes() {
  useConfigureOnPremRoutes();
  useConfigureEnterpriseRoutes();
}
